import { useSyncExternalStoreWithSelector } from "use-sync-external-store/shim/with-selector";
import {
  headerStore,
  type HeaderStoreState,
} from "src/stores/header/header.store";

export function useHeaderStore<T>(
  selector: (state: HeaderStoreState) => T,
  isEqual: (a: T, b: T) => boolean = Object.is
): T {
  return useSyncExternalStoreWithSelector(
    headerStore.subscribe,
    headerStore.getSnapshot,
    headerStore.getServerSnapshot,
    selector,
    isEqual
  );
}

const selectIsOpenNavigationMenu = (state: HeaderStoreState) =>
  state.isOpenNavigationMenu;
const selectIsOpenSearch = (state: HeaderStoreState) => state.isOpenSearch;
const selectGuestLookupIntent = (state: HeaderStoreState) =>
  state.guestLookupIntent;

export function useIsOpenNavigationMenu(): boolean {
  return useHeaderStore(selectIsOpenNavigationMenu);
}

export function useIsOpenSearch(): boolean {
  return useHeaderStore(selectIsOpenSearch);
}

export function useGuestLookupIntent(): HeaderStoreState["guestLookupIntent"] {
  return useHeaderStore(selectGuestLookupIntent);
}
